import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FreeloadingForm from "./FreeloadingForm";

import { useAddFreeloadingMutation } from "store/services/freeloadingApi";


const FreeloadingCreateScreen = () => {

  const navigate = useNavigate();

  const [vendorPaymentTerms, setVendorPaymentTerms] = useState(null);

  const breadcrumbs = [
    { title: "Loading", path: "/app/crm/shipment-loading/list" },
    // { title: "Freeloading", path: "/app/crm/freeloading/list" },
    { title: "New Free Loading" },
  ];

  // RTK query hook for adding freeloading
  const [addFreeloading, { isLoading }] = useAddFreeloadingMutation();

  const handleCreateFreeloading = async (data) => {
    try {
      const response = await addFreeloading(data).unwrap();
      const freeloadingId = response?.loading?._id;
      if (!freeloadingId) {
        throw new Error("Freeloading ID not found in response");
      }
      toast.success("Freeloading successfully created!");
      navigate(`/app/crm/shipment-loading/${freeloadingId}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create freeloading!"
      );
    }
  };

  // Callback to receive selected vendor's paymentTerms from CollectionForm
  const handleVendorChange = (vendor) => {
    setVendorPaymentTerms(vendor?.paymentTerms || null);
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        {vendorPaymentTerms !== "Contract" &&  (
          <Alert severity="info" sx={{ mb: 2 }}>
            To collect shipments, you must add a price with <strong>Charge</strong> type first.
          </Alert>
        )}
        <FreeloadingForm
          isBusy={isLoading}
          onSubmit={handleCreateFreeloading}
          onVendorChange={handleVendorChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default FreeloadingCreateScreen;
